import { formatGymPrice } from '../../../utils/gymMoney';

export const memberReport = [];
export const attendanceReport = [];
export const revenueReport = [];
export const membershipReport = [];
export const trainerReport = [];
export const profitReport = [];
export const branchReport = [];
export const financeReport = [];

export const memberOptions = [];

export const durationOptions = [
  'This Month',
  'Last 3 Months',
  'Last 6 Months',
  'This Year',
];

export function formatCurrency(amount) {
  const value = Number(amount) || 0;
  const formatted = formatGymPrice(Math.abs(value));
  return value < 0 ? `-${formatted}` : formatted;
}
